import { render, staticRenderFns } from "./InfoDetailsWidget.vue?vue&type=template&id=dbc6f79c&scoped=true"
import script from "./InfoDetailsWidget.vue?vue&type=script&lang=js"
export * from "./InfoDetailsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc6f79c",
  null
  
)

/* custom blocks */
import block0 from "./InfoDetailsWidget.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports